import { useCallback, useState } from "react";

export function useForceRender() {
  const [_count, setCount] = useState(0);
  return useCallback(() => setCount((count) => count + 1), []);
}
